import { TRUSTED_IMAGES } from '@/mocks/home';

export default function TrustedBy() {
  return (
    <section id="about" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg border border-primary-700 bg-primary-800 px-6 py-12 md:px-14 md:py-16">
          <div className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-primary-700/60"></div>
          <div className="relative grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
            <div>
              <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">
                Trust &amp; Reliability
              </span>
              <h2 className="mt-3 font-heading text-3xl font-extrabold leading-tight text-background-50 md:text-4xl">
                Trusted by Businesses Every Day
              </h2>
              <p className="mt-5 max-w-md text-sm leading-relaxed text-secondary-200 md:text-base">
                From banks and medical centers to HOAs and resorts, teams across Southwest Florida rely on Crystal Clean
                to keep their facilities spotless — day in and day out.
              </p>
              <div className="mt-8 grid grid-cols-2 gap-6 sm:max-w-md">
                <div>
                  <p className="font-heading text-3xl font-extrabold text-accent-400">45+</p>
                  <p className="text-xs font-medium uppercase tracking-wider text-secondary-200">Years in business</p>
                </div>
                <div>
                  <p className="font-heading text-3xl font-extrabold text-accent-400">100%</p>
                  <p className="text-xs font-medium uppercase tracking-wider text-secondary-200">Satisfaction focus</p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              {TRUSTED_IMAGES.map((img) => (
                <div
                  key={img.alt}
                  className="relative aspect-square w-full overflow-hidden rounded-lg border-2 border-primary-600"
                >
                  <img src={img.src} alt={img.alt} title={`${img.alt} — Crystal Clean`} className="h-full w-full object-cover object-top" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}